var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext } from 'react';
import { useNoteSetup } from '../hooks';
export var noteSetupContext = createContext({});
export var NoteSetupProvider = function (_a) {
    var appointmentId = _a.appointmentId, children = _a.children;
    var noteSetupQuery = useNoteSetup(appointmentId);
    return (_jsx(noteSetupContext.Provider, __assign({ value: { appointmentId: appointmentId, noteSetupQuery: noteSetupQuery } }, { children: children })));
};
export var useInNoteSetupContext = function () {
    var state = useContext(noteSetupContext);
    return !!state.appointmentId;
};
export var useNoteSetupContext = function () {
    var state = useContext(noteSetupContext);
    return __assign(__assign({}, state), state.noteSetupQuery);
};
